export default {
	'the-subscripter': ''
}